'use client';

import React from 'react';

import Link from 'next/link';

import { Card, CardActionArea, CardProps } from '@mui/material';

interface LinkCardProps extends CardProps {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

/**
 * LinkCard - A clickable card component for navigation or actions
 * The entire card is clickable and can either navigate to a URL or trigger an action
 */
export const LinkCard: React.FC<LinkCardProps> = ({ href, onClick, children, ...props }) => {
  if (!href && !onClick) {
    throw new Error('LinkCard requires either href or onClick prop');
  }

  return (
    <Card {...props}>
      <CardActionArea
        component={href ? Link : 'button'}
        href={href}
        onClick={onClick}
        sx={{ textDecoration: 'none', color: 'inherit' }}
      >
        {children}
      </CardActionArea>
    </Card>
  );
};
